import { Fragment, useState, useEffect, useRef, useCallback } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Form, Input, Space, Table, Tooltip, message, Avatar, Typography, Drawer } from 'antd';
import { getJudgesListApi, addJudgesApi } from '@services/Selection';
import { uniqBy } from 'lodash';
import WorkExperiences from '@/components/common/WorkExperiences';
import ExpertProfileDrawer from '@/components/Expert/profile';
import './AddGuest.less';
import { TABLE_PAGE_SIZE_OPTIONS } from '@/utils/property';
const { Text } = Typography;

const AddGuest = ({ closeAddUserDrawer, visibleAddUserDrawer, setVisibleAddUserDrawer, onResetGuest, currentTopics, sid, getJudgesList, addJudges }) => {
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [inPageSize, setInPageSize] = useState(10);
    const [inPage, setInPage] = useState(1);
    const [inTotal, setInTotal] = useState(0);
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(false);
    const isSearchRef = useRef(null);
    const [expertForm] = Form.useForm();
    const [inForm] = Form.useForm();
    const params = useParams();
    const [filObj, setFilObj] = useState({
        name: '',
        mobile: '',
    });

    let { id, pid } = params || {};
    if (sid) {
        id = sid;
    }

    const guestSelectionTableColumns = [
        {
            title: '姓名',
            dataIndex: 'memUsername',
            width: 150,
            render: (_, record) => {
                return (
                    <Fragment>
                        <Avatar style={{ marginRight: '4px' }} src={record?.expertAvatar} />
                        <span style={{ minWidth: '36px', display: 'inline-block' }}>{record.memUsername}</span>
                    </Fragment>
                );
            },
        },
        {
            title: '性别',
            dataIndex: 'memGender',
            width: 80,
            render: (_, record) => (record.memGender === 1 ? '男' : record.memGender === 0 ? '女' : <Text type="secondary">&ndash;</Text>),
        },
        {
            title: '手机号',
            name: 'memMobile',
            width: 150,
            render: (_, record) => (
                <Fragment>
                    <span>{record.memMobile}</span>
                </Fragment>
            ),
        },
        {
            title: '单位任职',
            dataIndex: 'ssoMemberWorkExperiencesEntities',
            render: (_, record) => <WorkExperiences workExperiences={record?.ssoMemberWorkExperiencesEntities} />,
        },
        {
            title: '状态',
            dataIndex: 'selected',
            width: 100,
            render: (_, record) => (record.selected === 1 ? <Text type="success">已邀请</Text> : record.selected === 0 ? <Text type="secondary">未邀请</Text> : <Text type="secondary">&ndash;</Text>),
        },
    ];

    // 已选专家表格列定义（添加操作列）
    const guestSelectedTableColumns = [
        {
            title: '姓名',
            dataIndex: 'memUsername',
            width: 150,
            render: (_, record) => {
                return (
                    <Fragment>
                        <Avatar style={{ marginRight: '4px' }} src={record?.expertAvatar} />
                        <span style={{ minWidth: '36px', display: 'inline-block' }}>{record.memUsername}</span>
                    </Fragment>
                );
            },
        },
        {
            title: '性别',
            dataIndex: 'memGender',
            width: 80,
            render: (_, record) => (record.memGender === 1 ? '男' : record.memGender === 0 ? '女' : <Text type="secondary">&ndash;</Text>),
        },
        {
            title: '手机号',
            name: 'memMobile',
            width: 150,
            render: (_, record) => (
                <Fragment>
                    <span>{record.memMobile}</span>
                </Fragment>
            ),
        },
        {
            title: '单位任职',
            dataIndex: 'ssoMemberWorkExperiencesEntities',
            render: (_, record) => <WorkExperiences workExperiences={record?.ssoMemberWorkExperiencesEntities} />,
        },
        {
            title: '状态',
            dataIndex: 'selected',
            width: 100,
            render: (_, record) => (record.selected === 1 ? <Text type="success">已邀请</Text> : record.selected === 0 ? <Text type="secondary">未邀请</Text> : <Text type="secondary">&ndash;</Text>),
        },
        {
            title: '操作',
            width: 100,
            fixed: 'right',
            render: (_, record) => (
                <Button type="link" size="small" icon={<i className="bi bi-x-circle-fill"></i>} onClick={() => removeGuest(record)}>
                    移除
                </Button>
            ),
        },
    ];

    const [guestsToSelect, setGuestsToSelect] = useState([]);
    const [guestsSelected, setGuestsSelected] = useState([]);
    const [guestsFilter, setGuestsFilter] = useState([]);

    /** 嵌套打开专家档案抽屉（新增专家 expertId=0，或表单内跳转查看已有专家） */
    const [expertProfileDrawerOpen, setExpertProfileDrawerOpen] = useState(false);
    const [expertProfileExpertId, setExpertProfileExpertId] = useState(null);

    // 移除已选专家
    const removeGuest = record => {
        // 从已选列表中移除
        const newGuestsSelected = guestsSelected.filter(item => item.id !== record.id);
        setGuestsSelected(newGuestsSelected);
        setGuestsFilter(newGuestsSelected);
        setInTotal(newGuestsSelected.length);

        // 同时更新选中状态
        const newSelected = selected.filter(id => id !== record.id);
        setSelected(newSelected);
    };

    // 添加用户
    const addGuests = () => {
        if (addJudges) {
            addJudges({ judgeIds: guestsSelected.map(item => item.id), projectId: pid, stageId: id, topicId: params.tid, caseId: params.id });
        } else {
            const expertIds = guestsSelected.map(item => {
                return { expertId: item.id };
            });
            console.log(expertIds, 'expertIds');
            const params = {
                judgesVos: expertIds,
                projectId: pid,
                stageId: id,
                type1: currentTopics[0]?.topicId || '',
                type2: currentTopics[1]?.topicId || '',
                type3: currentTopics[2]?.topicId || '',
            };
            addJudgesApi(params).then(res => {
                if (res && res.status_code === 200) {
                    message.success('添加成功');
                    setVisibleAddUserDrawer(false);
                    onResetGuest();
                }
            });
        }
        // TODO
    };

    const guestToSelectSelection = {
        selectedRowKeys: selected,
        getCheckboxProps: record => ({
            disabled: record.selected === 1,
        }),
        onSelect: (record, select) => {
            if (select) {
                // 选中后立即添加到已选用户
                const isExist = guestsSelected.some(item => item.id === record.id);
                if (!isExist) {
                    const newGuestsSelected = [...guestsSelected, record];
                    setGuestsSelected(newGuestsSelected);
                    setGuestsFilter(newGuestsSelected);
                    setInTotal(newGuestsSelected.length);
                }

                const originalArray = [...selected, record.id];
                const uniqueArray = Array.from(new Set(originalArray));
                setSelected([...uniqueArray]);
            } else {
                // 取消选中时从已选用户中移除
                const newGuestsSelected = guestsSelected.filter(item => item.id !== record.id);
                setGuestsSelected(newGuestsSelected);
                setGuestsFilter(newGuestsSelected);
                setInTotal(newGuestsSelected.length);

                const re = selected.filter(it => it !== record.id);
                setSelected([...re]);
            }
        },
        onSelectAll: (select, selectedRows, changeRows) => {
            if (select) {
                // 全选时添加当前页所有用户到已选用户
                const newGuestsSelected = [...guestsSelected];

                // 使用 selectedRows 参数，它包含当前页所有被选中的行
                selectedRows.forEach(row => {
                    const isExist = newGuestsSelected.some(item => item.id === row.id);
                    if (!isExist && row.selected !== 1) {
                        // 确保不添加已邀请的专家
                        newGuestsSelected.push(row);
                    }
                });

                setGuestsSelected(newGuestsSelected);
                setGuestsFilter(newGuestsSelected);
                setInTotal(newGuestsSelected.length);

                // 更新选中的 ID 列表
                const selectedIds = selectedRows.map(i => i.id);
                const originalArray = [...selected, ...selectedIds];
                const uniqueArray = Array.from(new Set(originalArray));
                setSelected([...uniqueArray]);
            } else {
                // 全不选时从已选用户中移除当前页的所有用户
                const changeIds = changeRows.map(i => i.id);
                const newGuestsSelected = guestsSelected.filter(item => !changeIds.includes(item.id));
                setGuestsSelected(newGuestsSelected);
                setGuestsFilter(newGuestsSelected);
                setInTotal(newGuestsSelected.length);

                // 从选中列表中移除当前页的 ID
                const newSelectedIds = selected.filter(id => !changeIds.includes(id));
                setSelected(newSelectedIds);
            }
        },
    };

    const getExpertlist = useCallback(
        async (page, pageSize, mobile, name) => {
            setLoading(true);
            isSearchRef.current = false;
            const obj = {
                page,
                pageSize,
                username: name,
                mobile,
                projectId: pid,
                stageId: id,
            };

            if (getJudgesList) {
                const parma = { page, limit: pageSize, stageId: id, caseId: params.id, topicId: params.tid };
                if (mobile) {
                    parma.mobile = mobile;
                }
                if (name) {
                    parma.username = name;
                }
                const list = await getJudgesList(parma);
                setGuestsToSelect(list.list);
                setTotal(list.totalCount);
                setLoading(false);
            } else {
                const res = await getJudgesListApi(obj);
                if (res.status_code === 200) {
                    setGuestsToSelect(res.data.list);
                    setTotal(res.data.totalCount);
                    setLoading(false);
                }
            }
        },
        [pid, id, getJudgesList, params.id, params.tid],
    );

    const onChangePage = (page, pageSize) => {
        setPage(page);
        setPageSize(pageSize);
    };

    const onChangeInPage = (page, pageSize) => {
        setInPage(page);
        setInPageSize(pageSize);
    };

    const expertFormFinish = res => {
        isSearchRef.current = true;
        setFilObj({
            name: expertForm.getFieldValue('name') ? expertForm.getFieldValue('name') : '',
            mobile: expertForm.getFieldValue('mobile') ? expertForm.getFieldValue('mobile') : '',
        });
        if ((expertForm.getFieldValue('name') === undefined || expertForm.getFieldValue('name') === '') && (expertForm.getFieldValue('mobile') === undefined || expertForm.getFieldValue('mobile') === '')) {
            setPage(1);
        }
        expertForm.resetFields();
    };

    const filterIn = () => {
        const old = [...guestsSelected];
        if (inForm.getFieldValue('name') !== undefined || inForm.getFieldValue('name') !== '') {
            const fil = guestsFilter.filter(item => {
                return item?.memUsername.indexOf(inForm.getFieldValue('name')) > -1;
            });
            setGuestsSelected([...fil]);
            setInTotal(fil.length);
        } else {
            setGuestsSelected([...old]);
            setInTotal(old.length);
        }
    };

    const closeExpertProfileDrawer = useCallback(() => {
        setExpertProfileDrawerOpen(false);
        setExpertProfileExpertId(null);
    }, []);

    const handleExpertProfileRefreshList = useCallback(() => {
        const { mobile, name } = filObj;
        getExpertlist(page, pageSize, mobile, name);
    }, [filObj, page, pageSize, getExpertlist]);

    const toAddExpert = () => {
        setExpertProfileExpertId(0);
        setExpertProfileDrawerOpen(true);
    };

    useEffect(() => {
        const { mobile, name } = filObj;
        if (visibleAddUserDrawer) {
            if (isSearchRef.current === true) {
                getExpertlist(1, pageSize, mobile, name);
            } else {
                getExpertlist(page, pageSize, mobile, name);
            }
        }
    }, [page, pageSize, filObj, visibleAddUserDrawer, getExpertlist]);

    useEffect(() => {
        setGuestsSelected([]);
        setSelected([]);
    }, [visibleAddUserDrawer]);

    useEffect(() => {
        if (!visibleAddUserDrawer) {
            setExpertProfileDrawerOpen(false);
            setExpertProfileExpertId(null);
        }
    }, [visibleAddUserDrawer]);

    return (
        <div>
            <Drawer
                closable={{ placement: 'end' }}
                title="添加专家"
                placement="bottom"
                size="100%"
                destroyOnHidden
                open={visibleAddUserDrawer}
                onClose={closeAddUserDrawer}
                footer={
                    <div className="custom-drawer-footer" style={{ textAlign: 'right' }}>
                        <Space>
                            <Button onClick={closeAddUserDrawer}>取消</Button>
                            <Button type="primary" onClick={addGuests}>
                                确定
                            </Button>
                        </Space>
                    </div>
                }
            >
                <div className="guest-selection-area">
                    <div className="guests-to-select box-hover-shadow">
                        <div className="guest-selection-title">
                            <span>
                                <i className="bi bi-caret-down-fill"></i> 可选专家
                            </span>
                            <div className="toolbar">
                                <Button type="primary" size="small" onClick={toAddExpert}>
                                    新增专家
                                </Button>
                            </div>
                        </div>
                        <div className="guest-selection-filter">
                            <Form layout="inline" size="small" form={expertForm}>
                                <Form.Item label="姓名" name="name">
                                    <Input placeholder="专家姓名" />
                                </Form.Item>
                                <Form.Item label="手机" name="mobile">
                                    <Input placeholder="专家手机号" />
                                </Form.Item>
                                <Form.Item>
                                    <Button icon={<i className="bi bi-search"></i>} onClick={expertFormFinish}>
                                        检索
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                        <Table
                            size="small"
                            columns={guestSelectionTableColumns}
                            dataSource={guestsToSelect}
                            rowKey={row => row.id}
                            rowSelection={{
                                type: 'checkbox',
                                ...guestToSelectSelection,
                            }}
                            loading={loading}
                            pagination={{
                                total: total,
                                showTotal: () => `共${total}条`,
                                current: page,
                                pageSize: pageSize,
                                pageSizeOptions: TABLE_PAGE_SIZE_OPTIONS,
                                onChange: onChangePage,
                                showQuickJumper: true,
                                showSizeChanger: true,
                            }}
                            onRow={record => ({
                                onClick: () => {
                                    // 检查行是否被禁用
                                    const isDisabled = record.selected === 1;
                                    if (isDisabled) return; // 如果被禁用，则不执行任何操作

                                    const isSelected = selected.includes(record.id);
                                    guestToSelectSelection.onSelect(record, !isSelected);
                                },
                                style: { cursor: 'pointer' },
                            })}
                        />
                    </div>

                    {/* 移除中间的按钮操作区域 */}

                    <div className="guests-selected box-hover-shadow">
                        <div className="guest-selection-title">
                            <i className="bi bi-caret-down-fill"></i> 已选专家
                        </div>
                        <div className="guest-selection-filter">
                            <Form layout="inline" size="small" form={inForm}>
                                <Form.Item label="姓名" name="name">
                                    <Input placeholder="专家姓名" />
                                </Form.Item>
                                <Form.Item>
                                    <Button onClick={filterIn} icon={<i className="bi bi-funnel"></i>}>
                                        过滤
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                        <Table
                            size="small"
                            columns={guestSelectedTableColumns}
                            dataSource={guestsSelected}
                            rowKey={rows => rows.id}
                            pagination={{
                                // total: inTotal,
                                showTotal: () => `共${inTotal}条`,
                                current: inPage,
                                pageSize: inPageSize,
                                pageSizeOptions: TABLE_PAGE_SIZE_OPTIONS,
                                onChange: onChangeInPage,
                                showQuickJumper: true,
                                showSizeChanger: true,
                            }}
                        />
                    </div>
                </div>
            </Drawer>

            <ExpertProfileDrawer
                open={expertProfileDrawerOpen}
                expertId={expertProfileExpertId}
                openInEditMode={false}
                onClose={closeExpertProfileDrawer}
                onRefreshList={handleExpertProfileRefreshList}
                onOpenExpertDetail={id => {
                    if (!id) {
                        return;
                    }
                    setExpertProfileExpertId(id);
                }}
                zIndex={1100}
            />
        </div>
    );
};

export default AddGuest;
